import { createSlice } from '@reduxjs/toolkit'

export const initialState: any = {
  categories: {
    data: [],
    loading: false,
    error: null,
  },
  wishList: {
    data: [],
    loading: false,
    error: null,
    meta: {},
  },
  basket: {
    data: [],
    loading: false,
    error: null,
  },
}

const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState,
  reducers: {},
})

export const { actions } = wishlistSlice

const wishlistReducer = wishlistSlice.reducer

export default wishlistReducer
